"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "doc-management" };
var _hoisted_2 = { class: "doc-header" };
var _hoisted_3 = { class: "header-content" };
var _hoisted_4 = { class: "header-actions" };
var _hoisted_5 = ["disabled"];
var _hoisted_6 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spin"
};
var _hoisted_7 = {
    key: 1,
    class: "glyphicon glyphicon-download-alt"
};
var _hoisted_8 = {
    key: 0,
    class: "pdfs-access-gate"
};
var _hoisted_9 = {
    key: 0,
    class: "loading-state"
};
var _hoisted_10 = {
    key: 1,
    class: "empty-state"
};
var _hoisted_11 = {
    key: 2,
    class: "doc-sections"
};
var _hoisted_12 = { class: "doc-section" };
var _hoisted_13 = { class: "section-title" };
var _hoisted_14 = { class: "title-info" };
var _hoisted_15 = { class: "doc-count" };
var _hoisted_16 = { class: "section-content" };
var _hoisted_17 = {
    key: 0,
    class: "no-docs"
};
var _hoisted_18 = {
    key: 1,
    class: "doc-grid"
};
var _hoisted_19 = { class: "doc-info" };
var _hoisted_20 = ["href", "title"];
var _hoisted_21 = ["title", "disabled", "onClick"];
var _hoisted_22 = {
    key: 2,
    class: "doc-state"
};
var _hoisted_23 = {
    key: 3,
    class: "doc-state"
};
var _hoisted_24 = { class: "doc-meta" };
var _hoisted_25 = { class: "doc-type" };
var _hoisted_26 = { class: "doc-size" };
var _hoisted_27 = { class: "doc-date" };
var _hoisted_28 = { class: "doc-actions" };
var _hoisted_29 = ["onClick"];
var _hoisted_30 = { class: "action-menu" };
var _hoisted_31 = { class: "menu-content" };
var _hoisted_32 = ["disabled", "onClick"];
var _hoisted_33 = ["disabled", "onClick"];
var _hoisted_34 = ["onClick"];
var _hoisted_35 = { class: "doc-section" };
var _hoisted_36 = { class: "section-title" };
var _hoisted_37 = { class: "title-info" };
var _hoisted_38 = { class: "doc-count" };
var _hoisted_39 = { class: "section-content" };
var _hoisted_40 = {
    key: 0,
    class: "no-docs"
};
var _hoisted_41 = {
    key: 1,
    class: "doc-grid"
};
var _hoisted_42 = { class: "doc-info" };
var _hoisted_43 = ["href", "title"];
var _hoisted_44 = ["title", "disabled", "onClick"];
var _hoisted_45 = {
    key: 2,
    class: "doc-state"
};
var _hoisted_46 = {
    key: 3,
    class: "doc-state"
};
var _hoisted_47 = { class: "doc-meta" };
var _hoisted_48 = { class: "doc-type" };
var _hoisted_49 = { class: "doc-size" };
var _hoisted_50 = { class: "doc-date" };
var _hoisted_51 = { class: "doc-actions" };
var _hoisted_52 = ["onClick"];
var _hoisted_53 = { class: "action-menu" };
var _hoisted_54 = { class: "menu-content" };
var _hoisted_55 = ["disabled", "onClick"];
var _hoisted_56 = ["disabled", "onClick"];
var _hoisted_57 = ["onClick"];
var _hoisted_58 = { class: "doc-section" };
var _hoisted_59 = { class: "section-title" };
var _hoisted_60 = { class: "title-info" };
var _hoisted_61 = { class: "doc-count" };
var _hoisted_62 = { class: "section-content" };
var _hoisted_63 = {
    key: 0,
    class: "no-docs"
};
var _hoisted_64 = {
    key: 1,
    class: "doc-grid"
};
var _hoisted_65 = { class: "doc-info" };
var _hoisted_66 = ["href", "title"];
var _hoisted_67 = ["title", "disabled", "onClick"];
var _hoisted_68 = {
    key: 2,
    class: "doc-state"
};
var _hoisted_69 = {
    key: 3,
    class: "doc-state"
};
var _hoisted_70 = { class: "doc-meta" };
var _hoisted_71 = { class: "doc-type" };
var _hoisted_72 = { class: "doc-size" };
var _hoisted_73 = { class: "doc-date" };
var _hoisted_74 = { class: "doc-actions" };
var _hoisted_75 = ["onClick"];
var _hoisted_76 = { class: "action-menu" };
var _hoisted_77 = { class: "menu-content" };
var _hoisted_78 = ["disabled", "onClick"];
var _hoisted_79 = ["disabled", "onClick"];
var _hoisted_80 = ["onClick"];
var _hoisted_81 = { class: "modal-content upload-modal" };
var _hoisted_82 = { class: "modal-body" };
var _hoisted_83 = { class: "form-group" };
var _hoisted_84 = { class: "type-selector" };
var _hoisted_85 = ["accept"];
var _hoisted_86 = {
    key: 0,
    class: "upload-placeholder"
};
var _hoisted_87 = {
    key: 1,
    class: "selected-file"
};
var _hoisted_88 = { class: "file-preview" };
var _hoisted_89 = { class: "file-details" };
var _hoisted_90 = { class: "file-name" };
var _hoisted_91 = { class: "file-size" };
var _hoisted_92 = {
    key: 0,
    class: "upload-error"
};
var _hoisted_93 = { class: "modal-footer" };
var _hoisted_94 = ["disabled"];
var _hoisted_95 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spin"
};
var _hoisted_96 = {
    key: 1,
    class: "glyphicon glyphicon-cloud-upload bi-cloud-upload"
};
var _hoisted_97 = { class: "modal-content upload-modal" };
var _hoisted_98 = { class: "modal-body" };
var _hoisted_99 = { class: "replace-info" };
var _hoisted_100 = ["accept"];
var _hoisted_101 = {
    key: 0,
    class: "upload-placeholder"
};
var _hoisted_102 = {
    key: 1,
    class: "selected-file"
};
var _hoisted_103 = { class: "file-preview" };
var _hoisted_104 = { class: "file-details" };
var _hoisted_105 = { class: "file-name" };
var _hoisted_106 = { class: "file-size" };
var _hoisted_107 = { class: "modal-footer" };
var _hoisted_108 = ["disabled"];
var _hoisted_109 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spin"
};
var _hoisted_110 = {
    key: 1,
    class: "glyphicon glyphicon-refresh"
};
var _hoisted_111 = { class: "modal-content delete-modal" };
var _hoisted_112 = { class: "modal-body" };
var vue_3 = require("vue");
var axios_1 = require("axios");
var fileUrl_1 = require("@/utils/fileUrl");
var keyonFiles_1 = require("@/api/keyonFiles");
var credentialDocuments_1 = require("@/utils/credentialDocuments");
var apis_1 = require("@/constants/apis");
var vuex_1 = require("vuex");
var privileges_1 = require("@/stores/privileges");
var privileges_2 = require("@/constants/privileges");
// State
exports.default = (0, vue_1.defineComponent)({
    __name: 'PdfsProviderDocuments',
    setup: function (__props) {
        var _this = this;
        var isLoading = (0, vue_3.ref)(true);
        var isDownloading = (0, vue_3.ref)(false);
        var isUploading = (0, vue_3.ref)(false);
        var documents = (0, vue_3.ref)([]);
        var openMenuId = (0, vue_3.ref)(null);
        var expandedSections = (0, vue_3.ref)({
            insurance: true,
            license: true,
            misc: true
        });
        var store = (0, vuex_1.useStore)();
        // Upload Modal State
        var showUploadModal = (0, vue_3.ref)(false);
        var uploadType = (0, vue_3.ref)('');
        var selectedFile = (0, vue_3.ref)(null);
        var uploadError = (0, vue_3.ref)('');
        var isDragOver = (0, vue_3.ref)(false);
        var fileInput = (0, vue_3.ref)(null);
        // Replace Modal State
        var showReplaceModal = (0, vue_3.ref)(false);
        var documentToReplace = (0, vue_3.ref)(null);
        var replaceFile = (0, vue_3.ref)(null);
        var replaceInput = (0, vue_3.ref)(null);
        // Delete Modal State
        var showDeleteModal = (0, vue_3.ref)(false);
        var documentToDelete = (0, vue_3.ref)(null);
        // Computed
        var insuranceDocuments = (0, vue_3.computed)(function () {
            return documents.value.filter(function (d) { return d.type === 'insurance'; });
        });
        var licenseDocuments = (0, vue_3.computed)(function () {
            return documents.value.filter(function (d) { return d.type === 'license'; });
        });
        var miscDocuments = (0, vue_3.computed)(function () {
            return documents.value.filter(function (d) { return d.type === 'misc'; });
        });
        var allDocuments = (0, vue_3.computed)(function () { return documents.value; });
        // read Vuex getters
        var allData = (0, vue_3.computed)(function () { return store.getters['login/getAllData']; });
        var patient = (0, vue_3.computed)(function () { var _a; return (_a = allData.value) === null || _a === void 0 ? void 0 : _a.patient; });
        // The logged-in account's own type - drives the page title so a plain org
        // Administrator (no NPI, no dual caregiver role) sees "Administrator
        // Documents" rather than the previously-hardcoded "Provider Documents".
        var currentAccountType = (0, vue_3.ref)('');
        var accountTypeLabels = {
            'Administrator': 'Administrator',
            'Provider': 'Provider',
            'Registered Nurse': 'Nurse',
            'Licensed Practical Nurse': 'Nurse',
            'Home Health Aid': 'Home Health Aide',
            'Home Health Aide': 'Home Health Aide',
            'Allied Professional': 'Allied Professional',
        };
        var pageTitle = (0, vue_3.computed)(function () {
            var label = accountTypeLabels[currentAccountType.value];
            return label ? "".concat(label, " Documents") : 'My Documents';
        });
        function fetchCurrentAccountType() {
            return __awaiter(this, void 0, void 0, function () {
                var res, rows, me, e_1;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', {
                                    Account: {
                                        API_Meth: 'GetAccountUsers',
                                        accountnumber: (_a = patient.value) === null || _a === void 0 ? void 0 : _a.externId2,
                                    },
                                }, { headers: { 'Content-Type': 'application/json;' } })];
                        case 1:
                            res = _c.sent();
                            rows = Array.isArray((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) ? res.data.data : [];
                            me = rows.find(function (r) { var _a; return String((r === null || r === void 0 ? void 0 : r.unique_ID) || '') === String(((_a = patient.value) === null || _a === void 0 ? void 0 : _a.externId) || ''); });
                            currentAccountType.value = (me === null || me === void 0 ? void 0 : me.account_type) || '';
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _c.sent();
                            console.error('Failed to determine current account type:', e_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        // A plain Administrator gets every caregiver's documents org-wide; any other
        // type sees only their own. keyon decides what is returned:
        // ListCredentialDocuments refuses scope 'org' without privilege 60
        // (view_caregiver_documents), so the gate below is a display hint only.
        var showsAggregatedView = (0, vue_3.computed)(function () { return currentAccountType.value === 'Administrator'; });
        var canViewCaregiverDocuments = (0, vue_3.computed)(function () { return !showsAggregatedView.value || (0, privileges_1.usePrivilegesStore)().effectiveGranted(privileges_2.PRIVILEGES.VIEW_CAREGIVER_DOCUMENTS); });
        var listScope = (0, vue_3.computed)(function () {
            return showsAggregatedView.value && canViewCaregiverDocuments.value ? 'org' : 'own';
        });
        function fetchDocuments() {
            return __awaiter(this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isLoading.value = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, getPdfList()];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _a.sent();
                            console.error('Failed to fetch documents:', error_1);
                            return [3 /*break*/, 5];
                        case 4:
                            isLoading.value = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        // One row per stored file, from keyon's own records; no names or paths are
        // built here.
        function getPdfList() {
            return __awaiter(this, void 0, void 0, function () {
                var scope, r;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            scope = listScope.value;
                            return [4 /*yield*/, (0, keyonFiles_1.listCredentialDocuments)({ scope: scope })];
                        case 1:
                            r = _a.sent();
                            documents.value = r.ok ? (0, credentialDocuments_1.mapCredentialItems)(r.items, { scope: scope }) : [];
                            if (!r.ok && r.message)
                                alert(r.message);
                            return [2 /*return*/];
                    }
                });
            });
        }
        // Section toggle
        function toggleSection(section) {
            expandedSections.value[section] = !expandedSections.value[section];
        }
        // Document menu
        function toggleDocMenu(docId) {
            openMenuId.value = openMenuId.value === docId ? null : docId;
        }
        function closeDocMenu() {
            openMenuId.value = null;
        }
        // View document: images and PDFs open from keyon by uid in a new tab. An office
        // or text file is never rendered in the browser (keyon serves it only as an
        // attachment), so View downloads it.
        function viewDocument(doc) {
            closeDocMenu();
            if (doc.availability !== 'available')
                return;
            if (doc.fileClass === 'other') {
                downloadDocument(doc);
                return;
            }
            var url = (0, fileUrl_1.keyonFileUrl)(doc.fileUid);
            if (!url) {
                alert(fileUrl_1.DOCUMENT_UNAVAILABLE_TEXT);
                return;
            }
            window.open(url, '_blank', 'noopener,noreferrer');
        }
        // Download single document
        function downloadDocument(doc) {
            return __awaiter(this, void 0, void 0, function () {
                var r, text;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            closeDocMenu();
                            return [4 /*yield*/, (0, keyonFiles_1.downloadKeyonFile)(doc.fileUid, doc.name)];
                        case 1:
                            r = _a.sent();
                            if (r.ok)
                                return [2 /*return*/];
                            if (r.state === 'scan_pending')
                                doc.availability = 'scan_pending';
                            text = (0, keyonFiles_1.downloadRefusalText)(r.state);
                            if (text)
                                alert(text);
                            return [2 /*return*/];
                    }
                });
            });
        }
        // Download all as credentials.zip. A bundle has one owner (file.php
        // bundle=credentials&owner=), so the aggregated org view offers none.
        function downloadAll() {
            return __awaiter(this, void 0, void 0, function () {
                var r, text, error_2;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (showsAggregatedView.value || allDocuments.value.length === 0)
                                return [2 /*return*/];
                            isDownloading.value = true;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, (0, keyonFiles_1.downloadCredentialBundle)((_a = patient.value) === null || _a === void 0 ? void 0 : _a.externId)];
                        case 2:
                            r = _b.sent();
                            if (!r.ok) {
                                text = (0, keyonFiles_1.downloadRefusalText)(r.state);
                                if (text)
                                    alert(text);
                            }
                            return [3 /*break*/, 5];
                        case 3:
                            error_2 = _b.sent();
                            console.error('Failed to download documents:', error_2);
                            return [3 /*break*/, 5];
                        case 4:
                            isDownloading.value = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        // Upload Modal
        function openUploadModal() {
            showUploadModal.value = true;
            uploadType.value = '';
            selectedFile.value = null;
            uploadError.value = '';
        }
        function closeUploadModal() {
            showUploadModal.value = false;
            selectedFile.value = null;
            uploadError.value = '';
            uploadType.value = '';
        }
        function triggerFileInput() {
            var _a;
            (_a = fileInput.value) === null || _a === void 0 ? void 0 : _a.click();
        }
        function handleFileSelect(event) {
            var _a;
            var input = event.target;
            if ((_a = input.files) === null || _a === void 0 ? void 0 : _a[0]) {
                validateAndSetFile(input.files[0], 'upload');
            }
        }
        function handleDrop(event) {
            var _a;
            isDragOver.value = false;
            var file = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files[0];
            if (file) {
                validateAndSetFile(file, 'upload');
            }
        }
        // The same types and 20MB cap keyon applies; keyon still sniffs the bytes.
        function validateAndSetFile(file, mode) {
            uploadError.value = '';
            var v = (0, credentialDocuments_1.validateCredentialFile)(file);
            if (!v.ok) {
                uploadError.value = v.error;
                return;
            }
            if (mode === 'upload') {
                selectedFile.value = file;
            }
            else {
                replaceFile.value = file;
            }
        }
        // AddNewPdf as multipart with no Content-Type (api/keyonFiles.js); keyon
        // answers with the stored file's uid, and the list is re-read from keyon.
        function uploadDocument() {
            return __awaiter(this, void 0, void 0, function () {
                var r, error_3;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!selectedFile.value || !uploadType.value)
                                return [2 /*return*/];
                            isUploading.value = true;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 6, 7, 8]);
                            return [4 /*yield*/, (0, keyonFiles_1.uploadCredentialDocument)({
                                    file: selectedFile.value,
                                    category: uploadType.value,
                                    latest: true,
                                    accountnumber: (_a = patient.value) === null || _a === void 0 ? void 0 : _a.externId2,
                                    externid: (_b = patient.value) === null || _b === void 0 ? void 0 : _b.externId,
                                })];
                        case 2:
                            r = _c.sent();
                            if (!r.ok) return [3 /*break*/, 4];
                            closeUploadModal();
                            return [4 /*yield*/, getPdfList()];
                        case 3:
                            _c.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            alert(r.message || 'Upload failed');
                            _c.label = 5;
                        case 5: return [3 /*break*/, 8];
                        case 6:
                            error_3 = _c.sent();
                            uploadError.value = 'Failed to upload document. Please try again.';
                            console.error('Upload failed:', error_3 === null || error_3 === void 0 ? void 0 : error_3.message);
                            return [3 /*break*/, 8];
                        case 7:
                            isUploading.value = false;
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        }
        // Replace Modal (its menu entry is commented out in the template; removing and
        // uploading again is the supported flow)
        function openReplaceModal(doc) {
            documentToReplace.value = doc;
            replaceFile.value = null;
            showReplaceModal.value = true;
            closeDocMenu();
        }
        function closeReplaceModal() {
            showReplaceModal.value = false;
            documentToReplace.value = null;
            replaceFile.value = null;
        }
        function triggerReplaceInput() {
            var _a;
            (_a = replaceInput.value) === null || _a === void 0 ? void 0 : _a.click();
        }
        function handleReplaceFileSelect(event) {
            var _a;
            var input = event.target;
            if ((_a = input.files) === null || _a === void 0 ? void 0 : _a[0]) {
                validateAndSetFile(input.files[0], 'replace');
            }
        }
        function handleReplaceDrop(event) {
            var _a;
            isDragOver.value = false;
            var file = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files[0];
            if (file) {
                validateAndSetFile(file, 'replace');
            }
        }
        // There is no replace endpoint: nothing is sent, and the dialog only closes.
        function replaceDocument() {
            closeReplaceModal();
        }
        // Delete Modal
        function confirmDelete(doc) {
            documentToDelete.value = doc;
            showDeleteModal.value = true;
            closeDocMenu();
        }
        function closeDeleteModal() {
            showDeleteModal.value = false;
            documentToDelete.value = null;
        }
        function deleteDocument() {
            return __awaiter(this, void 0, void 0, function () {
                var removed_1, r, error_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!documentToDelete.value)
                                return [2 /*return*/];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            removed_1 = documentToDelete.value;
                            return [4 /*yield*/, (0, keyonFiles_1.deleteCredentialDocument)({ file_uid: removed_1.fileUid })];
                        case 2:
                            r = _a.sent();
                            if (r.ok) {
                                documents.value = documents.value.filter(function (d) { return d.id !== removed_1.id; });
                                getPdfList();
                            }
                            else {
                                alert(r.message || 'Unable to remove the file. Please try again later.');
                            }
                            closeDeleteModal();
                            return [3 /*break*/, 4];
                        case 3:
                            error_4 = _a.sent();
                            console.error('Delete failed:', error_4);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        // Utility functions
        function getFileExtension(filename) {
            var _a;
            return ((_a = filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
        }
        function getFileIcon(extension) {
            var iconMap = {
                pdf: 'bi-file-pdf',
                jpg: 'bi-card-image',
                jpeg: 'bi-image',
                png: 'bi-image',
                webp: 'bi-image',
                doc: 'bi-file',
                docx: 'bi-file',
                xls: 'bi-file',
                xlsx: 'bi-file',
                txt: 'bi-file',
                csv: 'bi-file'
            };
            return iconMap[extension] || 'bi-file';
        }
        function getFileTypeClass(extension) {
            if (['jpg', 'jpeg', 'png', 'webp'].includes(extension))
                return 'image';
            if (['doc', 'docx', 'xls', 'xlsx', 'txt', 'csv'].includes(extension))
                return 'word';
            return 'pdf';
        }
        function formatFileSize(bytes) {
            if (bytes === 0)
                return '0 Bytes';
            var k = 1024;
            var sizes = ['Bytes', 'KB', 'MB', 'GB'];
            var i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
        }
        function formatDate(dateStr) {
            // keyon sends MySQL DATETIME text ('YYYY-MM-DD HH:MM:SS'), which Safari will
            // not parse with a space.
            var date = new Date(String(dateStr || '').replace(' ', 'T'));
            return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        }
        // Initialize
        // The list scope depends on the account type, so that is known before listing.
        (0, vue_3.onMounted)(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchCurrentAccountType()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, fetchDocuments()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        return function (_ctx, _cache) {
            var _a, _b;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("h1", null, [
                            _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-folder-open" }, null, -1)),
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(pageTitle.value), 1)
                        ]),
                        _cache[13] || (_cache[13] = (0, vue_2.createElementVNode)("p", { class: "header-subtitle" }, "Manage your insurance and license documents", -1))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (!showsAggregatedView.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                key: 0,
                                class: "btn-download",
                                onClick: downloadAll,
                                disabled: isDownloading.value
                            }, [
                                (isDownloading.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_7)),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(isDownloading.value ? 'Preparing...' : 'Download All'), 1)
                            ], 8, _hoisted_5))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn-upload",
                            onClick: openUploadModal
                        }, __spreadArray([], (_cache[14] || (_cache[14] = [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-cloud-upload" }, null, -1),
                            (0, vue_2.createTextVNode)(" Upload Document ", -1)
                        ])), true))
                    ])
                ]),
                (!canViewCaregiverDocuments.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, __spreadArray([], (_cache[15] || (_cache[15] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-lock" }, null, -1),
                        (0, vue_2.createElementVNode)("h3", null, "You do not have permission to view caregiver documents.", -1)
                    ])), true)))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                        (isLoading.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, __spreadArray([], (_cache[16] || (_cache[16] = [
                                (0, vue_2.createElementVNode)("div", { class: "loader" }, null, -1),
                                (0, vue_2.createElementVNode)("p", null, "Loading documents...", -1)
                            ])), true)))
                            : (allDocuments.value.length === 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                                    _cache[18] || (_cache[18] = (0, vue_2.createElementVNode)("div", { class: "empty-icon" }, [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-file" })
                                    ], -1)),
                                    _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("h3", null, "No Documents Found", -1)),
                                    _cache[20] || (_cache[20] = (0, vue_2.createElementVNode)("p", null, "Upload your insurance and license documents to get started.", -1)),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn-upload",
                                        onClick: openUploadModal
                                    }, __spreadArray([], (_cache[17] || (_cache[17] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-cloud-upload" }, null, -1),
                                        (0, vue_2.createTextVNode)(" Upload Your First Document ", -1)
                                    ])), true))
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "section-header",
                                            onClick: _cache[0] || (_cache[0] = function ($event) { return (toggleSection('insurance')); })
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                                _cache[22] || (_cache[22] = (0, vue_2.createElementVNode)("span", { class: "section-icon insurance" }, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-briefcase bi bi-suitcase" })
                                                ], -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                                    _cache[21] || (_cache[21] = (0, vue_2.createElementVNode)("h2", null, "Insurance Documents", -1)),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_15, (0, vue_2.toDisplayString)(insuranceDocuments.value.length) + " file" + (0, vue_2.toDisplayString)(insuranceDocuments.value.length !== 1 ? 's' : ''), 1)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("span", {
                                                class: (0, vue_2.normalizeClass)(["toggle-icon glyphicon", expandedSections.value.insurance ? 'bi-chevron-up' : 'bi-chevron-down'])
                                            }, null, 2)
                                        ]),
                                        (0, vue_2.createVNode)(vue_2.Transition, { name: "slide" }, {
                                            default: (0, vue_2.withCtx)(function () { return [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_16, [
                                                    (insuranceDocuments.value.length === 0)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_17, __spreadArray([], (_cache[23] || (_cache[23] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-info-sign" }, null, -1),
                                                            (0, vue_2.createTextVNode)(" No insurance documents uploaded yet ", -1)
                                                        ])), true)))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, [
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(insuranceDocuments.value, function (doc) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                    key: doc.id,
                                                                    class: "doc-card"
                                                                }, [
                                                                    (0, vue_2.createElementVNode)("div", {
                                                                        class: (0, vue_2.normalizeClass)(["doc-icon", getFileTypeClass(doc.extension)])
                                                                    }, [
                                                                        (0, vue_2.createElementVNode)("span", {
                                                                            class: (0, vue_2.normalizeClass)(["glyphicon", getFileIcon(doc.extension)])
                                                                        }, null, 2)
                                                                    ], 2),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                                                        (doc.availability === 'available' && doc.fileClass !== 'other')
                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                                                key: 0,
                                                                                href: (0, vue_2.unref)(fileUrl_1.keyonFileUrl)(doc.fileUid),
                                                                                target: "_blank",
                                                                                rel: "noopener noreferrer",
                                                                                class: "doc-name",
                                                                                title: doc.name
                                                                            }, (0, vue_2.toDisplayString)(doc.name), 9, _hoisted_20))
                                                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                                key: 1,
                                                                                type: "button",
                                                                                class: "doc-name doc-name-btn",
                                                                                title: doc.name,
                                                                                disabled: doc.availability !== 'available',
                                                                                onClick: function ($event) { return (downloadDocument(doc)); }
                                                                            }, (0, vue_2.toDisplayString)(doc.name), 9, _hoisted_21)),
                                                                        (doc.availability === 'scan_pending')
                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_22, (0, vue_2.toDisplayString)((0, vue_2.unref)(fileUrl_1.SCAN_PENDING_TEXT)), 1))
                                                                            : (doc.availability === 'unavailable')
                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_23, (0, vue_2.toDisplayString)((0, vue_2.unref)(fileUrl_1.DOCUMENT_UNAVAILABLE_TEXT)), 1))
                                                                                : (0, vue_2.createCommentVNode)("", true),
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_25, (0, vue_2.toDisplayString)(doc.extension.toUpperCase()), 1),
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_26, (0, vue_2.toDisplayString)(formatFileSize(doc.size)), 1),
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_27, (0, vue_2.toDisplayString)(formatDate(doc.uploadedAt)), 1)
                                                                        ])
                                                                    ]),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                                                        (0, vue_2.createElementVNode)("button", {
                                                                            class: "action-btn menu-btn",
                                                                            onClick: (0, vue_2.withModifiers)(function ($event) { return (toggleDocMenu(doc.id)); }, ["stop"])
                                                                        }, __spreadArray([], (_cache[24] || (_cache[24] = [
                                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-option-vertical bi-three-dots-vertical" }, null, -1)
                                                                        ])), true), 8, _hoisted_29),
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_30, [
                                                                            (0, vue_2.createElementVNode)("div", {
                                                                                class: "menu-backdrop",
                                                                                onClick: closeDocMenu
                                                                            }),
                                                                            (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                                                                (0, vue_2.createElementVNode)("button", {
                                                                                    disabled: doc.availability !== 'available',
                                                                                    onClick: function ($event) { return (viewDocument(doc)); }
                                                                                }, __spreadArray([], (_cache[25] || (_cache[25] = [
                                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-eye-open bi-eye-fill" }, null, -1),
                                                                                    (0, vue_2.createTextVNode)(" View ", -1)
                                                                                ])), true), 8, _hoisted_32),
                                                                                (0, vue_2.createElementVNode)("button", {
                                                                                    disabled: doc.availability !== 'available',
                                                                                    onClick: function ($event) { return (downloadDocument(doc)); }
                                                                                }, __spreadArray([], (_cache[26] || (_cache[26] = [
                                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-download bi-download" }, null, -1),
                                                                                    (0, vue_2.createTextVNode)(" Download ", -1)
                                                                                ])), true), 8, _hoisted_33),
                                                                                (0, vue_2.createElementVNode)("button", {
                                                                                    class: "danger",
                                                                                    onClick: function ($event) { return (confirmDelete(doc)); }
                                                                                }, __spreadArray([], (_cache[27] || (_cache[27] = [
                                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-trash bi-trash" }, null, -1),
                                                                                    (0, vue_2.createTextVNode)(" Delete ", -1)
                                                                                ])), true), 8, _hoisted_34)
                                                                            ])
                                                                        ], 512), [
                                                                            [vue_2.vShow, openMenuId.value === doc.id]
                                                                        ])
                                                                    ])
                                                                ]));
                                                            }), 128))
                                                        ]))
                                                ], 512), [
                                                    [vue_2.vShow, expandedSections.value.insurance]
                                                ])
                                            ]; }, undefined, true),
                                            _: 1
                                        })
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "section-header",
                                            onClick: _cache[1] || (_cache[1] = function ($event) { return (toggleSection('license')); })
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                                _cache[29] || (_cache[29] = (0, vue_2.createElementVNode)("span", { class: "section-icon license" }, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate bi-award-fill" })
                                                ], -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                                    _cache[28] || (_cache[28] = (0, vue_2.createElementVNode)("h2", null, "License Documents", -1)),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_38, (0, vue_2.toDisplayString)(licenseDocuments.value.length) + " file" + (0, vue_2.toDisplayString)(licenseDocuments.value.length !== 1 ? 's' : ''), 1)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("span", {
                                                class: (0, vue_2.normalizeClass)(["toggle-icon glyphicon", expandedSections.value.license ? 'bi-chevron-up' : 'bi-chevron-down'])
                                            }, null, 2)
                                        ]),
                                        (0, vue_2.createVNode)(vue_2.Transition, { name: "slide" }, {
                                            default: (0, vue_2.withCtx)(function () { return [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_39, [
                                                    (licenseDocuments.value.length === 0)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_40, __spreadArray([], (_cache[30] || (_cache[30] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-info-sign" }, null, -1),
                                                            (0, vue_2.createTextVNode)(" No license documents uploaded yet ", -1)
                                                        ])), true)))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_41, [
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(licenseDocuments.value, function (doc) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                    key: doc.id,
                                                                    class: "doc-card"
                                                                }, [
                                                                    (0, vue_2.createElementVNode)("div", {
                                                                        class: (0, vue_2.normalizeClass)(["doc-icon", getFileTypeClass(doc.extension)])
                                                                    }, [
                                                                        (0, vue_2.createElementVNode)("span", {
                                                                            class: (0, vue_2.normalizeClass)(["glyphicon", getFileIcon(doc.extension)])
                                                                        }, null, 2)
                                                                    ], 2),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                                                        (doc.availability === 'available' && doc.fileClass !== 'other')
                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                                                key: 0,
                                                                                href: (0, vue_2.unref)(fileUrl_1.keyonFileUrl)(doc.fileUid),
                                                                                target: "_blank",
                                                                                rel: "noopener noreferrer",
                                                                                class: "doc-name",
                                                                                title: doc.name
                                                                            }, (0, vue_2.toDisplayString)(doc.name), 9, _hoisted_43))
                                                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                                key: 1,
                                                                                type: "button",
                                                                                class: "doc-name doc-name-btn",
                                                                                title: doc.name,
                                                                                disabled: doc.availability !== 'available',
                                                                                onClick: function ($event) { return (downloadDocument(doc)); }
                                                                            }, (0, vue_2.toDisplayString)(doc.name), 9, _hoisted_44)),
                                                                        (doc.availability === 'scan_pending')
                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_45, (0, vue_2.toDisplayString)((0, vue_2.unref)(fileUrl_1.SCAN_PENDING_TEXT)), 1))
                                                                            : (doc.availability === 'unavailable')
                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_46, (0, vue_2.toDisplayString)((0, vue_2.unref)(fileUrl_1.DOCUMENT_UNAVAILABLE_TEXT)), 1))
                                                                                : (0, vue_2.createCommentVNode)("", true),
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_47, [
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_48, (0, vue_2.toDisplayString)(doc.extension.toUpperCase()), 1),
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_49, (0, vue_2.toDisplayString)(formatFileSize(doc.size)), 1),
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_50, (0, vue_2.toDisplayString)(formatDate(doc.uploadedAt)), 1)
                                                                        ])
                                                                    ]),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_51, [
                                                                        (0, vue_2.createElementVNode)("button", {
                                                                            class: "action-btn menu-btn",
                                                                            onClick: (0, vue_2.withModifiers)(function ($event) { return (toggleDocMenu(doc.id)); }, ["stop"])
                                                                        }, __spreadArray([], (_cache[31] || (_cache[31] = [
                                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-option-vertical bi-three-dots-vertical" }, null, -1)
                                                                        ])), true), 8, _hoisted_52),
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_53, [
                                                                            (0, vue_2.createElementVNode)("div", {
                                                                                class: "menu-backdrop",
                                                                                onClick: closeDocMenu
                                                                            }),
                                                                            (0, vue_2.createElementVNode)("div", _hoisted_54, [
                                                                                (0, vue_2.createElementVNode)("button", {
                                                                                    disabled: doc.availability !== 'available',
                                                                                    onClick: function ($event) { return (viewDocument(doc)); }
                                                                                }, __spreadArray([], (_cache[32] || (_cache[32] = [
                                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-eye-open bi-eye-fill" }, null, -1),
                                                                                    (0, vue_2.createTextVNode)(" View ", -1)
                                                                                ])), true), 8, _hoisted_55),
                                                                                (0, vue_2.createElementVNode)("button", {
                                                                                    disabled: doc.availability !== 'available',
                                                                                    onClick: function ($event) { return (downloadDocument(doc)); }
                                                                                }, __spreadArray([], (_cache[33] || (_cache[33] = [
                                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-download bi-download" }, null, -1),
                                                                                    (0, vue_2.createTextVNode)(" Download ", -1)
                                                                                ])), true), 8, _hoisted_56),
                                                                                (0, vue_2.createElementVNode)("button", {
                                                                                    class: "danger",
                                                                                    onClick: function ($event) { return (confirmDelete(doc)); }
                                                                                }, __spreadArray([], (_cache[34] || (_cache[34] = [
                                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-trash bi-trash" }, null, -1),
                                                                                    (0, vue_2.createTextVNode)(" Delete ", -1)
                                                                                ])), true), 8, _hoisted_57)
                                                                            ])
                                                                        ], 512), [
                                                                            [vue_2.vShow, openMenuId.value === doc.id]
                                                                        ])
                                                                    ])
                                                                ]));
                                                            }), 128))
                                                        ]))
                                                ], 512), [
                                                    [vue_2.vShow, expandedSections.value.license]
                                                ])
                                            ]; }, undefined, true),
                                            _: 1
                                        })
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_58, [
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "section-header",
                                            onClick: _cache[2] || (_cache[2] = function ($event) { return (toggleSection('misc')); })
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_59, [
                                                _cache[36] || (_cache[36] = (0, vue_2.createElementVNode)("span", { class: "section-icon misc" }, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-paperclip bi-paperclip" })
                                                ], -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_60, [
                                                    _cache[35] || (_cache[35] = (0, vue_2.createElementVNode)("h2", null, "Miscellaneous Documents", -1)),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_61, (0, vue_2.toDisplayString)(miscDocuments.value.length) + " file" + (0, vue_2.toDisplayString)(miscDocuments.value.length !== 1 ? 's' : ''), 1)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("span", {
                                                class: (0, vue_2.normalizeClass)(["toggle-icon glyphicon", expandedSections.value.misc ? 'bi-chevron-up' : 'bi-chevron-down'])
                                            }, null, 2)
                                        ]),
                                        (0, vue_2.createVNode)(vue_2.Transition, { name: "slide" }, {
                                            default: (0, vue_2.withCtx)(function () { return [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_62, [
                                                    (miscDocuments.value.length === 0)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_63, __spreadArray([], (_cache[37] || (_cache[37] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-info-sign" }, null, -1),
                                                            (0, vue_2.createTextVNode)(" No miscellaneous documents uploaded yet ", -1)
                                                        ])), true)))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_64, [
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(miscDocuments.value, function (doc) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                    key: doc.id,
                                                                    class: "doc-card"
                                                                }, [
                                                                    (0, vue_2.createElementVNode)("div", {
                                                                        class: (0, vue_2.normalizeClass)(["doc-icon", getFileTypeClass(doc.extension)])
                                                                    }, [
                                                                        (0, vue_2.createElementVNode)("span", {
                                                                            class: (0, vue_2.normalizeClass)(["glyphicon bi", getFileIcon(doc.extension)])
                                                                        }, null, 2)
                                                                    ], 2),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_65, [
                                                                        (doc.availability === 'available' && doc.fileClass !== 'other')
                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                                                key: 0,
                                                                                href: (0, vue_2.unref)(fileUrl_1.keyonFileUrl)(doc.fileUid),
                                                                                target: "_blank",
                                                                                rel: "noopener noreferrer",
                                                                                class: "doc-name",
                                                                                title: doc.name
                                                                            }, (0, vue_2.toDisplayString)(doc.name), 9, _hoisted_66))
                                                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                                key: 1,
                                                                                type: "button",
                                                                                class: "doc-name doc-name-btn",
                                                                                title: doc.name,
                                                                                disabled: doc.availability !== 'available',
                                                                                onClick: function ($event) { return (downloadDocument(doc)); }
                                                                            }, (0, vue_2.toDisplayString)(doc.name), 9, _hoisted_67)),
                                                                        (doc.availability === 'scan_pending')
                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_68, (0, vue_2.toDisplayString)((0, vue_2.unref)(fileUrl_1.SCAN_PENDING_TEXT)), 1))
                                                                            : (doc.availability === 'unavailable')
                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_69, (0, vue_2.toDisplayString)((0, vue_2.unref)(fileUrl_1.DOCUMENT_UNAVAILABLE_TEXT)), 1))
                                                                                : (0, vue_2.createCommentVNode)("", true),
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_70, [
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_71, (0, vue_2.toDisplayString)(doc.extension.toUpperCase()), 1),
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_72, (0, vue_2.toDisplayString)(formatFileSize(doc.size)), 1),
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_73, (0, vue_2.toDisplayString)(formatDate(doc.uploadedAt)), 1)
                                                                        ])
                                                                    ]),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_74, [
                                                                        (0, vue_2.createElementVNode)("button", {
                                                                            class: "action-btn menu-btn",
                                                                            onClick: (0, vue_2.withModifiers)(function ($event) { return (toggleDocMenu(doc.id)); }, ["stop"])
                                                                        }, __spreadArray([], (_cache[38] || (_cache[38] = [
                                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-option-vertical bi-three-dots-vertical" }, null, -1)
                                                                        ])), true), 8, _hoisted_75),
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_76, [
                                                                            (0, vue_2.createElementVNode)("div", {
                                                                                class: "menu-backdrop",
                                                                                onClick: closeDocMenu
                                                                            }),
                                                                            (0, vue_2.createElementVNode)("div", _hoisted_77, [
                                                                                (0, vue_2.createElementVNode)("button", {
                                                                                    disabled: doc.availability !== 'available',
                                                                                    onClick: function ($event) { return (viewDocument(doc)); }
                                                                                }, __spreadArray([], (_cache[39] || (_cache[39] = [
                                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-eye-open bi-eye-fill" }, null, -1),
                                                                                    (0, vue_2.createTextVNode)(" View ", -1)
                                                                                ])), true), 8, _hoisted_78),
                                                                                (0, vue_2.createElementVNode)("button", {
                                                                                    disabled: doc.availability !== 'available',
                                                                                    onClick: function ($event) { return (downloadDocument(doc)); }
                                                                                }, __spreadArray([], (_cache[40] || (_cache[40] = [
                                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-download bi-download" }, null, -1),
                                                                                    (0, vue_2.createTextVNode)(" Download ", -1)
                                                                                ])), true), 8, _hoisted_79),
                                                                                (0, vue_2.createElementVNode)("button", {
                                                                                    class: "danger",
                                                                                    onClick: function ($event) { return (confirmDelete(doc)); }
                                                                                }, __spreadArray([], (_cache[41] || (_cache[41] = [
                                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-trash bi-trash" }, null, -1),
                                                                                    (0, vue_2.createTextVNode)(" Delete ", -1)
                                                                                ])), true), 8, _hoisted_80)
                                                                            ])
                                                                        ], 512), [
                                                                            [vue_2.vShow, openMenuId.value === doc.id]
                                                                        ])
                                                                    ])
                                                                ]));
                                                            }), 128))
                                                        ]))
                                                ], 512), [
                                                    [vue_2.vShow, expandedSections.value.misc]
                                                ])
                                            ]; }, undefined, true),
                                            _: 1
                                        })
                                    ])
                                ]))
                    ], 64)),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (showUploadModal.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 0,
                            class: "modal-overlay",
                            onClick: (0, vue_2.withModifiers)(closeUploadModal, ["self"])
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_81, [
                                (0, vue_2.createElementVNode)("div", { class: "modal-header" }, [
                                    _cache[43] || (_cache[43] = (0, vue_2.createElementVNode)("h3", null, [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-cloud-upload bi bi-cloud-upload" }),
                                        (0, vue_2.createTextVNode)(" Upload Document ")
                                    ], -1)),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "close-btn",
                                        onClick: closeUploadModal
                                    }, __spreadArray([], (_cache[42] || (_cache[42] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove" }, null, -1)
                                    ])), true))
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_82, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_83, [
                                        _cache[47] || (_cache[47] = (0, vue_2.createElementVNode)("label", null, "Document Type *", -1)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_84, [
                                            (0, vue_2.createElementVNode)("button", {
                                                class: (0, vue_2.normalizeClass)(["type-btn", { active: uploadType.value === 'insurance' }]),
                                                onClick: _cache[3] || (_cache[3] = function ($event) { return (uploadType.value = 'insurance'); })
                                            }, __spreadArray([], (_cache[44] || (_cache[44] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-briefcase bi bi-suitcase" }, null, -1),
                                                (0, vue_2.createTextVNode)(" Insurance ", -1)
                                            ])), true), 2),
                                            (0, vue_2.createElementVNode)("button", {
                                                class: (0, vue_2.normalizeClass)(["type-btn", { active: uploadType.value === 'license' }]),
                                                onClick: _cache[4] || (_cache[4] = function ($event) { return (uploadType.value = 'license'); })
                                            }, __spreadArray([], (_cache[45] || (_cache[45] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate bi-patch-check-fill" }, null, -1),
                                                (0, vue_2.createTextVNode)(" License ", -1)
                                            ])), true), 2),
                                            (0, vue_2.createElementVNode)("button", {
                                                class: (0, vue_2.normalizeClass)(["type-btn", { active: uploadType.value === 'misc' }]),
                                                onClick: _cache[5] || (_cache[5] = function ($event) { return (uploadType.value = 'misc'); })
                                            }, __spreadArray([], (_cache[46] || (_cache[46] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-paperclipbi bi-paperclip" }, null, -1),
                                                (0, vue_2.createTextVNode)(" Miscellaneous ", -1)
                                            ])), true), 2)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)(["upload-zone", { 'drag-over': isDragOver.value }]),
                                        onDragover: _cache[7] || (_cache[7] = (0, vue_2.withModifiers)(function ($event) { return (isDragOver.value = true); }, ["prevent"])),
                                        onDragleave: _cache[8] || (_cache[8] = function ($event) { return (isDragOver.value = false); }),
                                        onDrop: (0, vue_2.withModifiers)(handleDrop, ["prevent"]),
                                        onClick: triggerFileInput
                                    }, [
                                        (0, vue_2.createElementVNode)("input", {
                                            ref_key: "fileInput",
                                            ref: fileInput,
                                            type: "file",
                                            accept: (0, vue_2.unref)(credentialDocuments_1.CREDENTIAL_ACCEPT),
                                            onChange: handleFileSelect,
                                            hidden: ""
                                        }, null, 40, _hoisted_85),
                                        (!selectedFile.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_86, __spreadArray([], (_cache[48] || (_cache[48] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-cloud-upload bi bi-cloud-upload" }, null, -1),
                                                (0, vue_2.createElementVNode)("p", null, "Drag and drop your file here", -1),
                                                (0, vue_2.createElementVNode)("span", { class: "or-text" }, "or", -1),
                                                (0, vue_2.createElementVNode)("span", { class: "browse-text" }, "Browse Files", -1),
                                                (0, vue_2.createElementVNode)("span", { class: "file-types" }, "PDF, JPG, PNG, WEBP, DOC, DOCX, XLS, XLSX, TXT, CSV (Max 20MB)", -1)
                                            ])), true)))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_87, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_88, [
                                                    (0, vue_2.createElementVNode)("span", {
                                                        class: (0, vue_2.normalizeClass)(["glyphicon bi", getFileIcon(getFileExtension(selectedFile.value.name))])
                                                    }, null, 2)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_89, [
                                                    (0, vue_2.createElementVNode)("span", _hoisted_90, (0, vue_2.toDisplayString)(selectedFile.value.name), 1),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_91, (0, vue_2.toDisplayString)(formatFileSize(selectedFile.value.size)), 1)
                                                ]),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "remove-file",
                                                    onClick: _cache[6] || (_cache[6] = (0, vue_2.withModifiers)(function ($event) { return (selectedFile.value = null); }, ["stop"]))
                                                }, __spreadArray([], (_cache[49] || (_cache[49] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi bi-x-lg" }, null, -1)
                                                ])), true))
                                            ]))
                                    ], 34),
                                    (uploadError.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_92, [
                                            _cache[50] || (_cache[50] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-exclamation-sign bi-exclamation-triangle" }, null, -1)),
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(uploadError.value), 1)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_93, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn-secondary",
                                        onClick: closeUploadModal
                                    }, "Cancel"),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn-primary",
                                        onClick: uploadDocument,
                                        disabled: !selectedFile.value || !uploadType.value || isUploading.value
                                    }, [
                                        (isUploading.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_95))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_96)),
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(isUploading.value ? 'Uploading...' : 'Upload Document'), 1)
                                    ], 8, _hoisted_94)
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ])),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (showReplaceModal.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 0,
                            class: "modal-overlay",
                            onClick: (0, vue_2.withModifiers)(closeReplaceModal, ["self"])
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_97, [
                                (0, vue_2.createElementVNode)("div", { class: "modal-header" }, [
                                    _cache[52] || (_cache[52] = (0, vue_2.createElementVNode)("h3", null, [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-refresh bi bi-arrow-clockwise" }),
                                        (0, vue_2.createTextVNode)(" Replace Document ")
                                    ], -1)),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "close-btn",
                                        onClick: closeReplaceModal
                                    }, __spreadArray([], (_cache[51] || (_cache[51] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove" }, null, -1)
                                    ])), true))
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_98, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_99, [
                                        _cache[54] || (_cache[54] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-info-sign" }, null, -1)),
                                        (0, vue_2.createElementVNode)("p", null, [
                                            _cache[53] || (_cache[53] = (0, vue_2.createTextVNode)("You are replacing: ", -1)),
                                            (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)((_a = documentToReplace.value) === null || _a === void 0 ? void 0 : _a.name), 1)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)(["upload-zone", { 'drag-over': isDragOver.value }]),
                                        onDragover: _cache[10] || (_cache[10] = (0, vue_2.withModifiers)(function ($event) { return (isDragOver.value = true); }, ["prevent"])),
                                        onDragleave: _cache[11] || (_cache[11] = function ($event) { return (isDragOver.value = false); }),
                                        onDrop: (0, vue_2.withModifiers)(handleReplaceDrop, ["prevent"]),
                                        onClick: triggerReplaceInput
                                    }, [
                                        (0, vue_2.createElementVNode)("input", {
                                            ref_key: "replaceInput",
                                            ref: replaceInput,
                                            type: "file",
                                            accept: (0, vue_2.unref)(credentialDocuments_1.CREDENTIAL_ACCEPT),
                                            onChange: handleReplaceFileSelect,
                                            hidden: ""
                                        }, null, 40, _hoisted_100),
                                        (!replaceFile.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_101, __spreadArray([], (_cache[55] || (_cache[55] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-cloud-upload" }, null, -1),
                                                (0, vue_2.createElementVNode)("p", null, "Drag and drop your new file here", -1),
                                                (0, vue_2.createElementVNode)("span", { class: "or-text" }, "or", -1),
                                                (0, vue_2.createElementVNode)("span", { class: "browse-text" }, "Browse Files", -1)
                                            ])), true)))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_102, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_103, [
                                                    (0, vue_2.createElementVNode)("span", {
                                                        class: (0, vue_2.normalizeClass)(["glyphicon", getFileIcon(getFileExtension(replaceFile.value.name))])
                                                    }, null, 2)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_104, [
                                                    (0, vue_2.createElementVNode)("span", _hoisted_105, (0, vue_2.toDisplayString)(replaceFile.value.name), 1),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_106, (0, vue_2.toDisplayString)(formatFileSize(replaceFile.value.size)), 1)
                                                ]),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "remove-file",
                                                    onClick: _cache[9] || (_cache[9] = (0, vue_2.withModifiers)(function ($event) { return (replaceFile.value = null); }, ["stop"]))
                                                }, __spreadArray([], (_cache[56] || (_cache[56] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove" }, null, -1)
                                                ])), true))
                                            ]))
                                    ], 34)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_107, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn-secondary",
                                        onClick: closeReplaceModal
                                    }, "Cancel"),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn-primary",
                                        onClick: replaceDocument,
                                        disabled: !replaceFile.value || isUploading.value
                                    }, [
                                        (isUploading.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_109))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_110)),
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(isUploading.value ? 'Replacing...' : 'Replace Document'), 1)
                                    ], 8, _hoisted_108)
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ])),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (showDeleteModal.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 0,
                            class: "modal-overlay",
                            onClick: (0, vue_2.withModifiers)(closeDeleteModal, ["self"])
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_111, [
                                (0, vue_2.createElementVNode)("div", { class: "modal-header danger" }, [
                                    _cache[58] || (_cache[58] = (0, vue_2.createElementVNode)("h3", null, [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-warning-sign" }),
                                        (0, vue_2.createTextVNode)(" Confirm Delete ")
                                    ], -1)),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "close-btn",
                                        onClick: closeDeleteModal
                                    }, __spreadArray([], (_cache[57] || (_cache[57] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi-x-circle" }, null, -1)
                                    ])), true))
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_112, [
                                    (0, vue_2.createElementVNode)("p", null, [
                                        _cache[59] || (_cache[59] = (0, vue_2.createTextVNode)("Are you sure you want to delete ", -1)),
                                        (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)((_b = documentToDelete.value) === null || _b === void 0 ? void 0 : _b.name), 1),
                                        _cache[60] || (_cache[60] = (0, vue_2.createTextVNode)("?", -1))
                                    ]),
                                    _cache[61] || (_cache[61] = (0, vue_2.createElementVNode)("p", { class: "warning-text" }, "This action cannot be undone.", -1))
                                ]),
                                (0, vue_2.createElementVNode)("div", { class: "modal-footer" }, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn-secondary",
                                        onClick: closeDeleteModal
                                    }, "Cancel"),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn-danger",
                                        onClick: deleteDocument
                                    }, __spreadArray([], (_cache[62] || (_cache[62] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-trash bi-trash" }, null, -1),
                                        (0, vue_2.createTextVNode)(" Delete Document ", -1)
                                    ])), true))
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]))
            ]));
        };
    }
});
